var map = {
	"./category_1.svg": "ba6b",
	"./category_2.svg": "21c2",
	"./category_3.svg": "8080",
	"./category_4.svg": "ad83",
	"./category_5.svg": "39d3",
	"./category_6.svg": "4932",
	"./category__2.svg": "257c",
	"./category__5.svg": "6281"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb63";